import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { useFormik } from 'formik';

import * as MultiStep from '@common/contexts/multiStepContext';
import AboDetails from '../AboDetails';
import PersonalDetails from '../PersonalDetails';
import Summary from '../Summary';
import { validationSchema, initialValues } from '../MobileOrderForm.helpers';

import useUpdateBirthDate from './hooks/useUpdateBirthDate';
import useSyncUserDataWithFormState from './hooks/useSyncUserDataWithFormState';
import useHandleSubmit from './hooks/useHandleSubmit';
import useHandleChange from './hooks/useHandleChange';

export const FormContext = createContext({
  formik: {},
  handleChange: () => {},
  termsLinks: {},
  providersList: [],
  handleSubmit: () => {},
  isFormSending: false,
});

const FormWrapper = ({ providersList, mobileTermsLinks }) => {
  const { t } = useTranslation();
  const {
    query: { plan },
  } = useRouter();
  const [initialFormState, setInitFormState] = useState({
    ...initialValues,
    mobile_plan: plan,
  });
  const [isFormSending, setIsFormSending] = useState(false);

  const formik = useFormik({
    initialValues: initialFormState,
    validationSchema,
    enableReinitialize: true,
  });

  const handleSubmit = useHandleSubmit(setIsFormSending, formik);
  const handleChange = useHandleChange(initialFormState, formik);

  useSyncUserDataWithFormState(initialFormState, setInitFormState);
  useUpdateBirthDate(formik);

  return (
    <form onSubmit={formik.handleSubmit} noValidate>
      <FormContext.Provider
        value={{
          formik,
          handleChange,
          termsLinks: mobileTermsLinks,
          providersList,
          handleSubmit,
          isFormSending,
        }}
      >
        <MultiStep.Stepper
          steps={[
            t('mobile.orderForm.stepper.aboDeatilsStepTitle', 'Auswahl'),
            t('mobile.orderForm.stepper.personalDetailsStepTitle', 'Adresse'),
            t('mobile.orderForm.stepper.summaryStepTitle', 'Übersicht'),
          ]}
        />
        <MultiStep.Step stepIndex={0}>
          <AboDetails />
        </MultiStep.Step>
        <MultiStep.Step stepIndex={1}>
          <PersonalDetails />
        </MultiStep.Step>
        <MultiStep.Step stepIndex={2}>
          <Summary />
        </MultiStep.Step>
      </FormContext.Provider>
    </form>
  );
};

FormWrapper.propTypes = {
  providersList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      logo: PropTypes.string,
    }),
  ).isRequired,
  mobileTermsLinks: PropTypes.shape({
    dataProtectionDeclaration: PropTypes.string,
    termsAndConditions: PropTypes.string,
  }).isRequired,
};

export default FormWrapper;
